import "./CollapsibleCardComp.css";
import { defineComponent as u, toRefs as k, openBlock as a, createElementBlock as h, createElementVNode as r, normalizeClass as b, toDisplayString as y, unref as o, createVNode as t, withCtx as s, createBlock as c, createCommentVNode as d, renderSlot as v } from "vue";
import { CollapsibleComp as g } from "./CollapsibleComp.js";
import { IconComp as n } from "./IconComp.js";
import { ButtonComp as B } from "./ButtonComp.js";
import { _ as x } from "./_plugin-vue_export-helper.dad06003.js";
const N = { class: "collapsible-card" }, V = { class: "card-body" }, E = /* @__PURE__ */ u({
  __name: "CollapsibleCardComp",
  props: {
    headline: { default: "" },
    collapsed: { type: Boolean, default: !1 },
    headerColor: { default: "dark" }
  },
  emits: ["click"],
  setup(p, { emit: i }) {
    const m = p, { headline: _, collapsed: l } = k(m), f = i, C = () => {
      f("click");
    };
    return (e, I) => (a(), h("div", N, [
      r("div", {
        class: b(["card-header", e.headerColor])
      }, [
        r("span", null, y(o(_)), 1),
        t(B, {
          onClick: C,
          blank: ""
        }, {
          default: s(() => [
            o(l) ? (a(), c(n, {
              key: 0,
              icon: "expand_more_small",
              color: e.headerColor === "dark" ? "#fff" : "#3b3f4a"
            }, null, 8, ["color"])) : d("", !0),
            o(l) ? d("", !0) : (a(), c(n, {
              key: 1,
              icon: "keyboard_control_key_small",
              color: e.headerColor === "dark" ? "#fff" : "#3b3f4a"
            }, null, 8, ["color"]))
          ]),
          _: 1
        })
      ], 2),
      r("div", V, [
        t(g, { toggle: o(l) }, {
          default: s(() => [
            v(e.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["toggle"])
      ])
    ]));
  }
});
const R = /* @__PURE__ */ x(E, [["__scopeId", "data-v-55e716ca"]]);
export {
  R as CollapsibleCardComp
};
//# sourceMappingURL=CollapsibleCardComp.js.map
